<template>
	<h3 class="card_title">
		<slot></slot>
	</h3>
</template>

<script type="text/babel">
export default {};
</script>
